import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { AppLogo } from "./AppLogo";

export const AppOutletLayout = () => {

    return (
        <Box height="100vh" display="flex" flexDirection="column">
            <AppLogo />
            <Box
                sx={{
                    flexGrow: 1,
                    overflow: 'auto'
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
}